import HllUI from '@/libs/hll-m-ui';
/**
 * 定义vue指令
 */
export default {
  install(Vue) {
    //使用v-backgroundColor ，设置页面背景颜色
    Vue.directive('backgroundColor', (el, binding) => {
      el.style.backgroundColor = binding.value;
    });
    //使用v-touching ，添加移动端hoverClass
    /**
     * 例:
     * html: <div class="btn" v-touching></div>
     * scss: .btn{&.hover{background:red}}
     * 动态绑定时,v-touching="false"才能取消hoverClass
     */
    Vue.directive(
      'touching',
      (() => {
        var on = function() {
          this.classList.add('hover');
        };
        var off = function() {
          this.classList.remove('hover');
        };
        return function(el, binding) {
          if (binding.value === false) {
            el.removeEventListener('touchstart', on);
            el.removeEventListener('touchend', off);
          } else {
            el.addEventListener('touchstart', on);
            el.addEventListener('touchend', off);
          }
        };
      })()
    );

    // 无限滚动
    // 需要绑定节流函数,以保证事件不会重复触发
    Vue.directive('infinite-scroll', {
      bind: function(el, binding) {
        let cb = binding.value;
        let distance = Number(el.getAttribute('infinite-scroll-distance'));
        distance = distance ? distance : 0;
        // 监听滚动事件
        window.addEventListener('scroll', function() {
          if (
            el.getBoundingClientRect().height ||
            el.getBoundingClientRect().bottom - distance <=
              document.body.offsetHeight
          ) {
            if (typeof cb === 'function') {
              cb();
            }
          }
        });
      }
    });
    // v-longTouchCopy 长按复制，传入指令的值为复制的内容
    Vue.directive('longTouchCopy', function(el, binding) {
      el.addEventListener('touchstart', longtouchstart);
      el.addEventListener('touchend', longtouchend);
      let timeOutEvent = '';
      function longtouchstart(e) {
        e.preventDefault();
        clearTimeout(timeOutEvent); //清除定时器
        timeOutEvent = setTimeout(() => {
          //执行长按要执行的内容，
          /*创建一个Input元素用来存放需要复制的数据*/
          let tag = document.createElement('input');
          /*设置需要复制的内容*/
          tag.value = binding.value;
          document.getElementsByTagName('body')[0].appendChild(tag);
          tag.select();
          /*复制到剪贴板*/
          document.execCommand('copy');
          /*完成复制，移除元素*/
          tag.value = '';
          tag.remove();
          HllUI.$hll.toast('内容已复制到剪贴板');
        }, 1000); //这里设置定时
      }
      //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
      function longtouchend() {
        clearTimeout(timeOutEvent);
      }
    });
    // 相对于之前的无限滚动指令，可以在任意显式指定了高度的元素上使用，只要能触发滚动事件即可
    /**
     * <div class="scrollContain" v-infiniteScroll="{cb:cb,distance:10}">
     *   <ul class="scrollContent">
     *     <li class="test" v-for="(item, index) in items" :key="index">{{item}}</li>
     *   </ul>
     * </div>
     *  cb：回调
     *  distance：触发距离，内容区域底部距离容器底部的临界距离，小于这个距离触发，单位px
     * */
    // 放在容器上，滚动到底部就触发callback，至于loading和end自行在callback处理
    // 容器的第一个子元素为列表渲染
    Vue.directive('infiniteScroll', {
      bind: (el, binding) => {
        let cb = binding.value.cb;
        let distance = binding.value.distance;
        el.addEventListener('scroll', () => {
          let containerHeight = el.clientHeight;
          let scrollTop = el.scrollTop;
          let contentHeight = el.firstChild.offsetHeight;
          //console.log(contentHeight - scrollTop - containerHeight, distance);
          if (contentHeight - scrollTop - containerHeight < distance) {
            cb();
          }
        });
      }
    });
  }
};
